import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getReferralsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/referrals");

  return response.data;
};
